import { formatDate } from "../../utility/formatDate";
import { Tag ,Progress} from "antd";

const TITLE_MAP = { ALL: "Title", COURSE: "Course", BUNDLE: "Curriculum" };

const renderProgress = (progress) => {
  const rounded = Number(progress?.toFixed(1));
  return (
    <Progress
      percent={rounded}
      size="small"
      type="circle"
      strokeColor={
        rounded >= 95 ? "#52c41a" : rounded >= 50 ? "#1890ff" : "#69c0ff"
      }
      format={(p) => `${p?.toFixed(1)}%`}
    />
  );
};

export const STATUS_STYLES = {
  Completed: {
    color: "#066710",
    background: "#EEFFF0",
    borderColor: "#95DE9D",
  },
  "In Progress": {
    color: "#C77A00",
    background: "#FFF8C7",
    borderColor: "#FBDC94",
  },
  default: {
    color: "#C80000",
    background: "#FFEEEE",
    borderColor: "#FFAAAA",
  },
};

export const renderStatus = (status) => {
  const { color, background, borderColor } =
    STATUS_STYLES[status] ?? STATUS_STYLES.default;

  return (
    <Tag
      style={{
        padding: "10px 16px",
        borderRadius: "10px",
        border: "1px solid",
        color,
        fontWeight: "500",
        borderColor,
        backgroundColor: background,
      }}
    >
      {status}
    </Tag>
  );
};

const COMMON_GROUP_COLUMNS = [
  {
    title: "Assigned At",
    dataIndex: "assignedAt",
    key: "assignedAt",
    render: formatDate,
  },
  {
    title: "Deadline",
    dataIndex: "deadline",
    key: "deadline",
    render: formatDate,
  },
  {
    title: "Avg Progress",
    dataIndex: "avgProgress",
    key: "avgProgress",
    render: renderProgress,
  },
  {
    title: "Status",
    dataIndex: "groupStatus",
    key: "groupStatus",
    render: renderStatus,
  },
  {
    title: "Worst Adherence",
    dataIndex: "worstAdherence",
    key: "worstAdherence",
  },
  {
    title: "Total Learners",
    dataIndex: "totalLearners",
    key: "totalLearners",
    width:100,
  },
];

export const getDynamicGroupColumnsReport = ({ subType }) => [
  {
    title: TITLE_MAP[subType] ?? "Title",
    key: "displayTitle",
    render: (_, record) => record.bundleName ?? record.courseTitle ?? "-",
    width:300,
  },
  ...COMMON_GROUP_COLUMNS,
];

export const LEARNER_COLUMNS = [
  {
    title: "Learner",
    dataIndex: "fullName",
    key: "fullName",
    width:250,
  },
  {
    title: "Progress",
    dataIndex: "courseCompletionPercentage",
    key: "courseCompletionPercentage",
    render: renderProgress,
    width:200,

  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: renderStatus,
    width:200,
  },
  {
    title: "Adherence",
    dataIndex: "adherence",
    key: "adherence",
    width:100,
  },
];

export const BUNDLE_COURSE_COLUMNS = [
  {
    title: "Course",
    dataIndex: "courseTitle",
    key: "courseTitle",
    width:250,
  },
  {
    title: "Avg Progress",
    dataIndex: "avgProgress",
    key: "avgProgress",
    render: renderProgress,
    width:200,

  },
  {
    title: "Status",
    dataIndex: "groupStatus",
    key: "groupStatus",
    render: renderStatus,
    width:150,
  },
  {
    title: "Worst Adherence",
    dataIndex: "worstAdherence",
    key: "worstAdherence",
    width:100,
  },
];